import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreateInvoicePayload, OdataObject, PlanInfoOdata, PromoCodePayload, TariffOdata, UnsubscribePayload } from '@common/models';
import { SharedOdataService } from '@common/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TariffsService extends SharedOdataService<TariffOdata> {
  private readonly http = inject(HttpClient);

  constructor() {
    super('Tariffs');
  }

  getAccountUrl(): Observable<string> {
    const odataService = this.odataFactory.CreateService<OdataObject<string>>(`/Me/GetAccountUrl`);

    return this.http.get<OdataObject<string>>(odataService.Query().GetUrl()).pipe(map((res) => res?.value));
  }

  getPlanInfo(): Observable<PlanInfoOdata> {
    const odataService = this.odataFactory.CreateService<PlanInfoOdata>(`/Me/PlanInfo`);

    return this.http.get<PlanInfoOdata>(odataService.Query().GetUrl());
  }

  getTariffs(): Observable<TariffOdata[]> {
    const odataService = this.odataFactory.CreateService<TariffOdata>('Tariffs');

    return this.fetchData<TariffOdata>(odataService).pipe(map((res) => res.data));
  }

  createInvoices(payload: CreateInvoicePayload): Observable<string> {
    const odataService = this.odataFactory.CreateService(`Tariffs/CreateInvoices`);

    return odataService
      .Post(payload)
      .Exec()
      .pipe(map((res: any) => res.value));
  }

  applyPromoCode(payload: PromoCodePayload): Observable<void> {
    const odataService = this.odataFactory.CreateService<void>(`Tariffs/ApplyPromoCode`);

    return odataService
      .Post(payload)
      .Exec()
      .pipe(map((res: any) => res.value));
  }

  // createInvoicesRedirect(data: AdditionPaymentPayload): Observable<any> {
  //   const formData = new FormData();
  //   for (const prop in data.payload) {
  //     formData.append(prop, data.payload[prop]);
  //   }
  //   return this.http.post(data.url, formData, {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded'
  //     }
  //   });
  // }

  createInvoice(payload: CreateInvoicePayload, id: string): Observable<string> {
    const odataService = this.odataFactory.CreateService(`Tariffs(${id})/CreateInvoice`);

    return odataService
      .Post(payload)
      .Exec()
      .pipe(map((res: any) => res.value));
  }

  // payInvoice(payload: InvoiceIdPayload): Observable<any> {
  //   const url = `/api/PayInvoice`;
  //   return this.http.post(url, payload);
  // }

  unsubscribeActivatedPlan(payload: UnsubscribePayload): Observable<void> {
    const odataService = this.odataFactory.CreateService(`Tariffs/CancelSubscription`);

    return odataService.Post(payload).Exec() as unknown as Observable<void>;
  }
}
